<template>
  <el-dialog
    class="modal-modify-takeawaySys"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content">
      <el-form
        ref="modify"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        class="platform-modify__form"
      >
        <el-form-item label="系统名称:" prop="systemName">
          <el-input
            v-model="formData.systemName"
            placeholder="必填"
            style="width: 440px;"
          ></el-input>
          <span class="input-tips">*支持32个中英文字符，支持标准符号</span>
        </el-form-item>

        <el-form-item label="父级应用:">
          <el-select
            v-model="formData.parentId"
            class="form-item__input"
            style="width: 440px;"
          >
            <el-option
              v-for="systemApp in systemApplicationList"
              :key="systemApp.id"
              :label="systemApp.name"
              :value="systemApp.id"
            ></el-option>
          </el-select>
          <span class="input-tips">选填，父级应用可以管理子级应用的数据</span>
        </el-form-item>

        <el-form-item label="系统Logo:" prop="systemLogo">
          <div class="row">
            <el-image :src="systemLogo">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <label for="upload">
              <input
                type="file"
                ref="systemLogo"
                @change="$_selectFile"
                name="upload"
                id="upload"
                style="display: none;"
              />
              <span class="select-btn__span">上传</span>
            </label>
            <span class="input-tips">*请上传1M以内图片</span>
          </div>
        </el-form-item>

        <el-form-item label="系统编码:" prop="systemCode">
          <el-input
            v-model="formData.systemCode"
            placeholder="选填"
            style="width: 440px;"
            :disabled="formType === 'edit'"
          ></el-input>
          <span class="input-tips">*支持32个英文数字字符，支持标准符号</span>
        </el-form-item>

        <el-form-item label="系统地址:" prop="systemUrl">
          <el-input
            v-model="formData.systemUrl"
            placeholder="必填"
            style="width: 440px;"
          ></el-input>
          <span class="input-tips">*url格式，需要有http://或https://</span>
        </el-form-item>

        <el-form-item label="应用类型:" prop="appType">
          <el-select
            v-model="formData.appType"
            class="form-item__input"
            style="width: 440px;"
          >
            <el-option label="内部系统" :value="1"></el-option>
            <el-option label="外部系统" :value="2"></el-option>
          </el-select>
          <span class="input-tips">*必选，仅内部账号可访问内部系统</span>
        </el-form-item>

        <el-form-item label="是否需要配置数据权限:" prop="needConfig">
          <el-select
            v-model="formData.needConfig"
            class="form-item__input"
            style="width: 440px;"
            :disabled="formType === 'edit'"
          >
            <el-option
              v-for="item in formData.booleans"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span class="input-tips">*必选</span>
        </el-form-item>

        <el-form-item label="浏览器图标:" prop="browserIcon">
          <div class="row">
            <el-image :src="browserIcon">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <label for="upload4">
              <input
                type="file"
                ref="browserIcon"
                @change="
                  $_selectFile($event, { key: 'browserIcon', ico: true })
                "
                name="upload4"
                id="upload4"
                style="display: none;"
              />
              <span class="select-btn__span">上传</span>
            </label>
            <span class="input-tips">*请上传1M以内.ico格式图片</span>
          </div>
        </el-form-item>

        <el-form-item label="浏览器标题:" prop="browserTitle">
          <el-input
            v-model="formData.browserTitle"
            placeholder="必填，请输入标题"
            style="width: 440px;"
          ></el-input>
          <span class="input-tips">*支持32个中英文字符，支持标准符号</span>
        </el-form-item>

        <el-form-item label="登录页图标:" prop="loginIcon">
          <div class="row">
            <el-image :src="loginIcon">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <label for="upload5">
              <input
                type="file"
                ref="loginIcon"
                @change="$_selectFile($event, { key: 'loginIcon' })"
                name="upload5"
                id="upload5"
                style="display: none;"
              />
              <span class="select-btn__span">上传</span>
            </label>
            <span class="input-tips">*请上传1M以内图片</span>
          </div>
        </el-form-item>

        <el-form-item label="登录页标题:" prop="loginTitle">
          <el-input
            v-model="formData.loginTitle"
            placeholder="选填，请输入标题"
            style="width: 440px;"
          ></el-input>
          <span class="input-tips">*支持32个中英文字符，支持标准符号</span>
        </el-form-item>

        <el-form-item label="欢迎页标题:" prop="homeTitle">
          <el-input
            v-model="formData.homeTitle"
            placeholder="选填，请输入标题"
            style="width: 440px;"
          ></el-input>
          <span class="input-tips">*支持32个中英文字符，支持标准符号</span>
        </el-form-item>

        <el-form-item label="头部标题:" prop="headTitle">
          <el-input
            v-model="formData.headTitle"
            placeholder="选填，请输入标题"
            style="width: 440px;"
          ></el-input>
          <span class="input-tips">*支持32个中英文字符，支持标准符号</span>
        </el-form-item>

        <el-form-item label="欢迎页头像:" prop="homeHead">
          <div class="row">
            <el-image :src="homeHead">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <label for="upload2">
              <input
                type="file"
                ref="homeHead"
                @change="$_selectFile($event, { key: 'homeHead' })"
                name="upload"
                id="upload2"
                style="display: none;"
              />
              <span class="select-btn__span">上传</span>
            </label>
            <span class="input-tips">*请上传1M以内图片</span>
          </div>
        </el-form-item>

        <el-form-item label="欢迎页图片:" prop="homeImage">
          <div class="row">
            <el-image :src="homeImage">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <label for="upload3">
              <input
                type="file"
                ref="homeImage"
                @change="$_selectFile($event, { key: 'homeImage' })"
                name="upload"
                id="upload3"
                style="display: none;"
              />
              <span class="select-btn__span">上传</span>
            </label>
            <span class="input-tips">*请上传3M以内图片</span>
          </div>
        </el-form-item>

        <el-form-item label="欢迎页描述:" prop="homeDesc" type="textarea">
          <el-input
            type="textarea"
            v-model="formData.homeDesc"
            style="width: 500px; height: 88px;"
            resize="none"
            placeholder="选填"
          ></el-input>
          <span class="input-tips"
            >*仅支持1000个中英文数字字符，支持标准符号</span
          >
        </el-form-item>

        <el-form-item label="备案信息:" prop="recordInfo">
          <el-input
            v-model="formData.recordInfo"
            placeholder="必填，请输入标题"
            style="width: 440px;"
          ></el-input>
          <span class="input-tips">*支持100个中英文字符，支持标准符号</span>
        </el-form-item>

        <el-form-item label="备注:" prop="memo" type="textarea">
          <el-input
            type="textarea"
            v-model="formData.memo"
            style="width: 500px; height: 48px;"
            resize="none"
            placeholder="选填"
          ></el-input>
          <span class="input-tips">*支持输入150个字符</span>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">确认</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectSys from "@/components/modal-select-orderCompany";
import OSS from "ali-oss";
export default {
  name: "modal-modify-takeawaySys",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} },
    systemApplicationList: { type: Array, default: () => [] },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      client: null,
      systemLogo: "",
      browserIcon: "",
      loginIcon: "",
      homeHead: "",
      homeImage: "",
      formData: {
        cidList: -1,
        systemName: "",
        parentId: null,
        systemLogo: "",
        systemCode: "",
        systemUrl: "",
        appType: 1,
        memo: "",
        needConfig: 1,
        booleans: [
          { value: 1, label: "是" },
          { value: 0, label: "否" },
        ],
        browserIcon: "",
        browserTitle: "",
        loginIcon: "",
        loginTitle: "",
        homeTitle: "",
        headTitle: "",
        homeHead: "",
        homeImage: "",
        recordInfo: "",
        homeDesc: "",
      },
      configInfos: {},
      modal: {
        show: false,
        title: "",
        template: "",
        data: {},
      },
      rules: {
        systemName: [
          { required: true, message: "请输入系统名称", trigger: "blur" },
          { validator: Utils.validName, trigger: "blur" },
        ],
        systemCode: [
          {
            validator: Utils.validName,
            trigger: "blur",
          }
        ],
        systemLogo: [
          {
            required: true,
            message: "请选择图片",
          },
        ],
        systemUrl: [
          { required: true, message: "请输入系统地址", trigger: "blur" },
          {
            required: true,
            validator(rule, value, callback) {
              const regUrl = /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i;
              if (value && !regUrl.test(value)) {
                callback(new Error("校验url格式，需要有http://或https://!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value && Utils.getStrLength(value) > 200) {
                callback(new Error("最多200个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        needConfig: [{ required: true, message: "请选择!", trigger: "blur" }],
        appType: [{ required: true, message: "请选择!", trigger: "blur" }],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 150) {
                callback(new Error("支持输入150个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        browserIcon: [
          {
            required: true,
            message: "请选择图片",
          },
        ],
        browserTitle: [
          { required: true, message: "请输入浏览器标题", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let length = Utils.getStrLength(value);
              if (value && length > 32) {
                callback(new Error("16个中文字符或32个英文字符!"));
              } else {
                callback();
              }
            },
          },
        ],
        loginIcon: [
          {
            required: true,
            message: "请选择图片",
          },
        ],
        loginTitle: [
          { required: true, message: "请输入登录页标题", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let length = Utils.getStrLength(value);
              if (value && length > 32) {
                callback(new Error("16个中文字符或32个英文字符!"));
              } else {
                callback();
              }
            },
          },
        ],
        homeTitle: [
          {
            validator: (rule, value, callback) => {
              let length = Utils.getStrLength(value);
              if (value && length > 32) {
                callback(new Error("16个中文字符或32个英文字符!"));
              } else {
                callback();
              }
            },
          },
        ],
        headTitle: [
          {
            validator: (rule, value, callback) => {
              let length = Utils.getStrLength(value);
              if (value && length > 32) {
                callback(new Error("16个中文字符或32个英文字符!"));
              } else {
                callback();
              }
            },
          },
        ],
        homeHead: [
          {
            required: true,
            message: "请选择图片",
          },
        ],
        homeImage: [
          {
            required: true,
            message: "请选择图片",
          },
        ],
        recordInfo: [
          { required: true, message: "请输入备案信息", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let length = Utils.getStrLength(value);
              if (value && length > 100) {
                callback(new Error("50个中文字符或100个英文字符!"));
              } else {
                callback();
              }
            },
          },
        ],
        homeDesc: [
          {
            validator: (rule, value, callback) => {
              let length = Utils.getStrLength(value);
              if (value && length > 1000) {
                callback(new Error("500个中文字符或1000个英文字符!"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    // 选择文件
    async $_selectFile(event, obj = {}) {
      let def = {
        key: "systemLogo",
        // width: 65,
        // height: 65,
        // flag: true,   //是否判断尺寸
        ico: false, //是否需要判断ico格式
        size: 1, //默认1M
      };
      let opts = Object.assign(def, obj);
      let self = this; // onload 里面不能用this
      const files = event.target.files;
      if (!files || files.length === 0) return false; //文件是否存在
      const file = event.target.files[0];
      const filename = file.name;
      let fileType = filename.replace(/([^\.]+\.)+(\S+)/g, "$2");

      // 校验文件格式
      if (opts.ico) {
        if (!~["ico"].indexOf(fileType)) {
          $MessageBox.alert({
            content: "请选择正确的文件!",
            onOk() {
              self.$refs[opts.key].value = "";
            },
          });
          return false;
        }
      } else {
        if (
          !~["gif", "jpg", "xlsx", "jpeg", "png", "GIF", "JPG", "PNG"].indexOf(
            fileType
          )
        ) {
          $MessageBox.alert({
            content: "请选择正确的文件!",
            onOk() {
              self.$refs[opts.key].value = "";
            },
          });
          return false;
        }
      }

      // 校验文件大小
      let fileSize = file.size / 1024 / 1024;
      if (fileSize > opts.size) {
        $MessageBox.alert({
          content: `上传的图片不能超过${opts.size}M`,
          onOk() {
            self.$refs[opts.key].value = "";
          },
        });
        return false;
      }
      // 判断尺寸
      // if(opts.flag){
      //   let flag = true;
      //   let imgSrc = window.URL.createObjectURL(file);
      //   let img = new Image();
      //   img.src = imgSrc;
      //   let imgLoad = new Promise((reslove)=>{
      //     img.onload = async function () {
      //       if ((img.width !== opts.width) || (img.height !== opts.height)) {
      //         $MessageBox.alert({
      //           content: '上传图片尺寸不正确！',
      //           onOk() {
      //             self.$refs[opts.key].value = "";
      //             flag = false;
      //             reslove();
      //           }
      //         });
      //       }else{
      //         reslove();
      //       }
      //     }
      //   });

      //   await imgLoad;
      //   if(!flag) return flag;
      // }

      const account = await this.$service.url("getUploadAccount");

      if (account.status !== 1) {
        $MessageBox.alert({ content: "获取配置失败" });
        return false;
      }
      let {
        region,
        accessKeyId,
        accessKeySecret,
        bucket,
        path,
        tmpPath,
      } = account.data;

      this.client = new OSS({
        region,
        accessKeyId,
        accessKeySecret,
        bucket,
      });

      // 上传阿里
      const filePath = `/${path}/${tmpPath}/paas/${Utils.createKey()}-${Utils.createKey()}-${Utils.createKey()}.${fileType}`;

      try {
        let result = await this.client.multipartUpload(filePath, file);
        if (result.res.status === 200) {
          let url = result.res.requestUrls[0];
          if (typeof innerRegion !== "undefined" && innerRegion !== "") {
            url = url.replace(region, innerRegion);
          }

          self[opts.key] = url.substring(
            0,
            url.lastIndexOf("?uploadId") === -1
              ? url.length
              : url.lastIndexOf("?uploadId")
          );
          self.formData[opts.key] = self[opts.key];
          this.$refs["modify"].validateField(opts.key);
        }
      } catch (e) {
        this.$_clearSelectedFile();
        if (e.name !== "cancel" && status !== 0) {
          $MessageBox.alert({ content: "上传失败" });
        }
      }
    },

    // 关闭选择品牌
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
    $_submit() {
      this.$refs["modify"].validate((valid) => {
        if (valid) {
          let {
            systemName,
            parentId,
            systemUrl,
            memo,
            systemCode,
            needConfig,
            browserTitle,
            loginTitle,
            homeTitle,
            headTitle,
            recordInfo,
            homeDesc,
            systemLogo,
            homeHead,
            homeImage,
            browserIcon,
            appType,
            loginIcon,
          } = this.formData;
          const self = this;
          let action = "addNewAppSysConfig";
          let postData = {
            systemName,
            parentId,
            systemLogo,
            systemUrl,
            memo,
            appType,
            systemCode,
            needConfig,
            browserIcon,
            browserTitle,
            loginIcon,
            loginTitle,
            homeTitle,
            headTitle,
            homeHead,
            homeImage,
            recordInfo,
            homeDesc,
          };
          if (self.formType === "edit") {
            action = "editNewAppSysConfig";
            Object.assign(postData, { cid: this.formData.cid });
          }
          $MessageBox.confirm({
            content: `是否确认${self.formType === "edit" ? '编辑' : '新增'}应用系统，结果会同步所有系统的同一个应用系统`,
            async onOk() {
              self.isLoading = true;
              try {
                await self.$service.post(action, postData).then((result) => {
                  if (result.$.checkResult(result, true)) {
                    $MessageBox.alert({
                      content: result.msg,
                      onOk() {
                        self.visible = false;
                        self.$emit("callback");
                      },
                    });
                  }
                });
              } finally {
                self.isLoading = false
              }
            },
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
  },
  created() {
    if (this.formType === "edit") {
      let {
        cid,
        systemName,
        parentId,
        systemLogo,
        systemUrl,
        memo,
        systemCode,
        needConfig,
        browserIcon,
        browserTitle,
        appType,
        loginIcon,
        loginTitle,
        homeTitle,
        headTitle,
        homeHead,
        homeImage,
        recordInfo,
        homeDesc,
      } = this.modalData;
      this.formData.cid = cid;
      this.formData.systemName = systemName;
      this.formData.parentId = parentId;
      this.formData.systemLogo = systemLogo;
      this.systemLogo = systemLogo;
      this.formData.systemUrl = systemUrl;
      this.formData.memo = memo;
      this.formData.systemCode = systemCode;
      this.formData.needConfig = needConfig;
      this.browserIcon = browserIcon;
      this.formData.browserIcon = browserIcon;
      this.formData.browserTitle = browserTitle;
      this.formData.homeTitle = homeTitle;
      this.formData.loginTitle = loginTitle;
      this.formData.headTitle = headTitle;
      this.formData.appType = appType;
      this.loginIcon = loginIcon;
      this.formData.loginIcon = loginIcon;
      (this.homeHead = homeHead), (this.homeImage = homeImage);
      (this.formData.homeHead = homeHead),
        (this.formData.homeImage = homeImage);
      this.formData.recordInfo = recordInfo;
      this.formData.homeDesc = homeDesc;
    }
    if (this.formType === "add") {
      this.formData.systemUrl = "http://";
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectSys,
  },
};
</script>

<style lang="scss" scoped>
.select-btn__span {
  display: inline-block;
  border-radius: 3px;
  background-color: #1895dd;
  min-width: 65px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
}
.modal-modify-takeawaySys {
  padding-left: 24px;
}
/deep/ .el-image {
  display: inline-block;
  width: 88px;
  height: 88px;
  line-height: 88px;
  vertical-align: bottom;
  margin-right: 10px;
  img {
    width: 100%;
    max-height: 100%;
  }
  .image-slot {
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #cacaca;
    i {
      font-size: 22px;
    }
  }
}
.content {
  padding: 20px 30px;
  height: 100%;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.select__btn {
  margin-left: 8px;
  vertical-align: top;
}
.type__chk {
  margin: {
    top: 5px;
    right: 64px;
  }
}
.input-tips {
  margin-left: 10px;
}
</style>
